export default "__VITE_ASSET__e20b81a7__"